import DepositRefundRealApi, { IDepositRefundApi } from "./deposit-refund.api";
import DepositRefundMockApi from "./deposit-refund.mock";

/**
 * true  = ใช้ข้อมูลจำลองในเครื่อง (ระหว่างรอ API spec จากทีม backend)
 * false = ยิง backend จริง
 *
 * นี่คือ "จุดเดียว" ที่ต้องแก้ตอน API จริงพร้อม — หน้าเพจไม่ต้องแตะแม้บรรทัดเดียว
 * เพราะทุกหน้า import จากโฟลเดอร์นี้ (`../../api/deposit-refund`) ไม่ได้ import ไฟล์ตรงๆ
 */
export const USE_MOCK_DEPOSIT_REFUND = false;

/**
 * assign ทั้งสอง class ให้ตัวแปรที่ประกาศ type ไว้ = บังคับให้ static method ตรง interface
 * ถ้า mock กับของจริง signature ไม่ตรงกัน compile จะพังที่บรรทัดนี้ ไม่ใช่ตอน runtime
 */
const realApi: IDepositRefundApi = DepositRefundRealApi;
const mockApi: IDepositRefundApi = DepositRefundMockApi;

/**
 * ห้าม destructure ตอนใช้ (`const { findAll } = DepositRefundApi`) เพราะเมธอดของจริง
 * เรียก `this.api` — destructure แล้ว this หลุด
 */
const DepositRefundApi: IDepositRefundApi = USE_MOCK_DEPOSIT_REFUND ? mockApi : realApi;

export default DepositRefundApi;
/** types/interface ทั้งหมด import จาก path เดียวกับ api */
export * from "./deposit-refund.api";
